for (var i = 0; i < stores.length; i++) {
  if (!stores[i]) continue;
  var storeName = stores[i].name.toLowerCase();
  if (specialProduct === true) {
    // if (storeName.indexOf('BOSSENSTORE.COM (CA)'.toLowerCase()) > -1) {delete stores[i];console.log('delete')}      
  }

  if (specialProduct2 === true) {
    if (storeName.indexOf('BOSSENSTORE.COM (CA)'.toLowerCase()) > -1) {delete stores[i];console.log('delete')}      
  }

  if (specialProduct3 === true) {
    if (storeName.indexOf('BOSSENSTORE.COM (NJ)'.toLowerCase()) > -1) {delete stores[i];console.log('delete')}      
  }

  if (specialProduct4 === true) {
    if (storeName.indexOf('BOSSENSTORE.COM (TX)'.toLowerCase()) > -1) {delete stores[i];console.log('delete')}      
  }

  if (specialProduct5 === true) {
    if (storeName.indexOf('Bossenstore.com (MD)'.toLowerCase()) > -1) {delete stores[i];console.log('delete')}      
  }

  if (specialProduct6 === true) {
    if (storeName.indexOf('Bossenstore.com (IL)'.toLowerCase()) > -1) {delete stores[i];console.log('delete')}      
  }
}


document.addEventListener('crPickupActivated', function (e) {
  jqCR('.cr-not-available').removeClass('cr-hide')
  // Add this script after the existing one
  const pickupDetails = document.getElementById('pickup-details');
  if (pickupDetails && pickupDetails.firstChild) {
    const requiredFieldParagraph = document.createElement('p');
    requiredFieldParagraph.textContent = '* indicates a required field';
    requiredFieldParagraph.classList.add('required');
    
    pickupDetails.insertBefore(requiredFieldParagraph, pickupDetails.firstChild);
  }
})


window.addEventListener('load', () => {
  // update attributes of pickup in store button
  const deliveryBtns = document.querySelectorAll('.cr-delivery-method');
  deliveryBtns?.forEach(btn => {
      if(btn) {
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
      if(btn.classList.contains('cr-delivery-method')) {
        btn.setAttribute('aria-controls', 'pickup-details');
        if(btn.classList.contains('selected')) {
          btn.setAttribute('aria-expanded', 'true');
        } else {
          btn.setAttribute('aria-expanded', 'false');
        }
      }

      // Add keyboard event listener
      btn.addEventListener('keydown', (e) => {
        // Check for Space (keyCode 32) or Enter (keyCode 13)
        if (e.keyCode === 32 || e.keyCode === 13) {
          // Prevent default behavior (scrolling for Space, form submission for Enter)
          e.preventDefault();
          // Trigger click event
          btn.click();
        }
      });

      btn.addEventListener('click', () => {
        if(btn.classList.contains('cr-delivery-method')) {
          setTimeout(() => {
            if(btn.classList.contains('selected')) {
              btn.setAttribute('aria-expanded', 'true');
            } else {
              btn.setAttribute('aria-expanded', 'false');
            }
          }, 300);
        } 
      })
    }
  })
})